import { Grid, Heart, Overlay } from './Thumbnail.styles';
import {
  DetailsGrid,
  DetailsWrapper,
  LowerSectionWrapper,
  Price,
  TrimAndMileage,
  Wrapper,
  YearMakeModel
} from './VehicleTile.styles';

const VehicleTileLoader = () => (
  <Wrapper className="loader" data-qa="vehicle-tile">
    <Grid>
      <Overlay className="flex-col items-end">
        <Heart />
      </Overlay>
    </Grid>
    <DetailsWrapper>
      <DetailsGrid>
        <p className="text-grey-3 tl-label-xs">Carvana Certified</p>
        <YearMakeModel>2000 Make Model</YearMakeModel>
        <TrimAndMileage>
          Trim <span className="px-4">•</span> 1,000 miles
        </TrimAndMileage>
      </DetailsGrid>
      <div className="mb-12 flex items-end">
        <Price>$00,000</Price>
      </div>
      <div>
        <div className="border-b border-grey-2" />
        <LowerSectionWrapper />
      </div>
    </DetailsWrapper>
  </Wrapper>
);

export default VehicleTileLoader;
